import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '../Ant';
import { StickyNote, StickyNoteYellow } from '../icons';

interface NoteIconsProps {
  hasImportantNotes?: boolean;
  hasImportantRelatedNotes?: boolean;
  hasNotes?: boolean;
}

const NoteIcons: React.FC<NoteIconsProps> = ({
  hasImportantNotes,
  hasImportantRelatedNotes,
  hasNotes,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {hasImportantNotes && (
        <Tooltip title={t('common:entityHasImportantNotes')} placement="top" arrow={false}>
          <Button
            aria-label={t('common:entityHasImportantNotes')}
            data-testid="important-note-button"
            className="important-note-btn"
            icon={<StickyNote />}
          />
        </Tooltip>
      )}
      {hasNotes && !hasImportantNotes && (
        <Tooltip title={t('common:entityHasRegularNotes')} placement="top" arrow={false}>
          <Button
            aria-label={t('common:entityHasRegularNotes')}
            data-testid="regular-note-button"
            className="important-note-btn"
            icon={<StickyNoteYellow />}
          />
        </Tooltip>
      )}
      {hasImportantRelatedNotes && (
        <Tooltip title={t('common:entityHasImportantRelatedNotes')} placement="top" arrow={false}>
          <Button
            aria-label={t('common:entityHasImportantRelatedNotes')}
            data-testid="important-related-note-button"
            className="important-note-btn"
            icon={<StickyNote className="text-clr-light-blue" />}
          />
        </Tooltip>
      )}
    </>
  );
};

export default NoteIcons;
